import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Container from "../../components/Container";
import Navbar from "../../components/Navbar";
import Player from "../../components/coursePlayer/Player";
import Playlist from "../../components/coursePlayer/Playlist";
import { useGetVideosQuery } from "../../features/videos/videosApi";

export default function CoursePlayer() {
  const { videoId } = useParams();
  localStorage.setItem("lastPlayedVideo", JSON.stringify(videoId));
  const { error, isLoading, data: videos } = useGetVideosQuery();

  useEffect(() => {
    document.title = "Course player";
  });
  return (
    <>
      <Navbar />
      <Container>
        <div className="grid grid-cols-3 gap-2 lg:gap-8">
          <Player videos={videos} isLoading={isLoading} error={error} />
          <Playlist videos={videos} isLoading={isLoading} error={error} />
        </div>
      </Container>
    </>
  );
}
